import { gql } from '@apollo/client'
import { WHOLE_DISPLAY_FRAGMENT } from '../fragments/WholeDisplayFragment'

export const GET_STORE_DISPLAY = gql`
  query GetDisplay($displayId: ID!) {
    display(displayId: $displayId) {
      ...WholeDisplay
    }
  }
  ${WHOLE_DISPLAY_FRAGMENT}
`
